import * as DB from "@/api/official.js"
import { request as Require } from "@/utils/require.js"
import { Toast } from "vant"

const state = () => ({
    backupData: {
        processAddIndex: 0,
        studentInfo: {},
        leaveType: {},
        leaveTypeName: '',
        startDateTime: '',
        endDateTime: '',
        approveInfo: {},
        remark: '',
        fileList: []
    },
    approvalResult: {}
});

const mutations = {
    setBackupData(state, payload) {
        state.backupData = payload
    },
    resetBackupData(state, payload) {
        state.backupData = payload || {
            processAddIndex: 0,
            studentInfo: {},
            leaveType: {},
            leaveTypeName: '',
            startDateTime: '',
            endDateTime: '',
            approveInfo: {},
            remark: '',
            fileList: []
        }
    }
};

const actions = {

   // 判断用户是否绑定手机号公众号用户
   async wechatsubscribe(context, params) {
    const r = await Require({
        api: DB.wechatsubscribe,
        params,
    })
    if (r.success) {
        return {
            success: r.success,
            data: r.data,
            message: r.message,
        }
    } else {
        Toast.fail(r.message)
    }
},

// 获取消息模块列表
// async messageModuleList(context, params) {
//     const r = await Require({
//       api: {
//         url: `${DB.messageModuleList.url}?token=hzjy`,
//         method: DB.messageModuleList.method,
//       },
//       params,
//     });
//     if (r.success) {
//       return {
//         success: r.success,
//         data: r.data,
//         message: r.message,
//       };
//     } else {
//       Toast.fail(r.message);
//     }
//   },

 // 绑定或者解绑公众号用户
 async subscribeopenidphone(context, params) {
    const r = await Require({
        api: DB.subscribeopenidphone,
        params,
    })
    if (r.success) {
        return {
            success: r.success,
            data: r.data,
            message: r.message,
        }
    } else {
        Toast.fail(r.message)
    }
},
// 校验微信用户是否关注公众号
async wechatCheck(context, params) {
    const r = await Require({
        api: DB.wechatCheck,
        params,
    })
    if (r.success) {
        return {
            success: r.success,
            data: r.data,
            message: r.message,
        }
    } else {
        Toast.fail(r.message)
    }
},

   
   

    
     




   

   


    // 撤销学生请假申请
    async leaveRevokeApply(context, params) {
        if (!params.id) {
            Toast.fail('缺少参数id')
            return
        }
        const r = await Require({
            api: Object.assign({}, DB.leaveRevokeApply, {
                url: DB.leaveRevokeApply.url + `/${params.id}`,
            }),
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

   

    
 
   

  

      // 获取验证码
      async commonsmscaptcha(context, params) {
        const r = await Require({
            api: DB.commonsmscaptcha,
            params,
        })
        if (r.success) {
            return {
                success: r.success,
                data: r.data,
                message: r.message,
            }
        } else {
            Toast.fail(r.message)
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}